import API_MAP from "../../constants/api";
import axiosClient, { axiosRecordingResponse } from "../axiosClient";

class ApiManagerRecordings {
    getRecordingByUser = ({ username, from, to, page_no, page_size = 5, room_name }) => {
        // return axiosClient.get("https://meet.viettelmeet.com/vmp/users/dev27/recordings?from=2023-12-04&page_no=0&page_size=10&room_name=&to=2023-12-29")
        return axiosClient.get(`${API_MAP.GET_ALL_RECORDINGS_BY_USER}${username}/recordings?from=${from}&page_no=${page_no}&page_size=${page_size}&room_name=${room_name}&to=${to}`)
    }
    getRecordingByZoom = (id) => {
        // return axiosClient.get("https://meet.viettelmeet.com/vmp/meetings/9866270067/recordings")
        return axiosClient.get(API_MAP.GET_ALL_RECORDINGS_BY_ZOOM + '/' + id + '/recordings')
    }
    downLoadRecording = (url) => {
        return axiosClient.get(url)
    }
    deleteRecordings = (id) => {
        return axiosClient.get(API_MAP.DELETE_BACK_RECORDING + "/" + id)
        // return axiosClient.post(API_MAP.DELETE_ROOM_RECORDING + '/' + username + '/' + 'recordings', {room_ids: ids})
    }
    deleteListMeetings = (username, ids) => {
        return axiosClient.delete(API_MAP.DELETE_ROOM_RECORDING + '/' + username + '/recordings', { room_ids: ids })
    }
    getMyRecordDetail = ({ started_date_from, started_date_to, recording_status, is_deleted, page = 0, size = 5, is_my_record, room_name, orderBy = 0, orderType = 0 }) => {
        return axiosRecordingResponse.get(`${API_MAP.RECORDING.GET_MY_RECORD_DETAIL}?started_date_from=${started_date_from}&started_date_to=${started_date_to}&is_deleted=${is_deleted}&page=${page}&size=${size}&is_my_record=${is_my_record}&room_name=${room_name}&orderBy=${orderBy}&orderType=${orderType}`)
    }
    getSharedUserList = ({recordId, page = 0, size = 5, user_name = '', expire_status = ''}) => {
        return axiosRecordingResponse.get(`${API_MAP.RECORDING.GET_SHARED_USER_LIST}/${recordId}?page=${page}&size=${size}&user_name=${user_name}&expire_status=${expire_status}`)
    }
    shareRecord = ({recordId, body}) => {
        return axiosRecordingResponse.post(`${API_MAP.RECORDING.SHARE_RECORD}/${recordId}`, body)
    }
    getDetailRecord = ({id}) => {
        return axiosClient.get(`${API_MAP.GET_DETAIL_RECORD}/${id}`)
    }
    downMyRecord = (recordId) => {
        return axiosClient.get(`${API_MAP.DOWNLOAD_MY_RECORD}?record_id=${recordId}`)
    }
    playbackRecord = (record_id) => {
        return axiosClient.get(`${API_MAP.PLAY_BACK_RECORD}/${record_id}/playlist.m3u8`)
    }
    /**
     * Dừng chia sẻ bản ghi
     * body = 
     * {
     *      user_ids: [id]
     * }
     * Nếu user_ids = [] => dừng chia sẻ tất cả
     * user_ids = [id] => dừng chia sẻ theo danh sách id
     * @param {string} recordId: id bản ghi
     * @param {object} body: danh sách user id 
     * @returns 
     */
    unshareRecord = ({recordId, body}) => {
        return axiosRecordingResponse.post(`${API_MAP.RECORDING.UNSHARE_RECORD}/${recordId}`, body)
    }
    updateSharingPermission = ({recordId, body}) => {
        return axiosRecordingResponse.post(`${API_MAP.RECORDING.UPDATE_SHARING_PERMISSION}/${recordId}`, body)
    }
    /**
     * body = {
            "shared_user_group_type": 1,
            "user_group_permission": 3
        }
        shared_user_group_type = 0 => người được share
        shared_user_group_type = 1 => tất cả mọi người
        user_group_permission = 2 => xem
        user_group_permission = 3 => download
     * @param {*} param0 
     * @returns 
     */
    updateSharingGroupPermission = ({recordId, body}) => {
        return axiosRecordingResponse.post(`${API_MAP.RECORDING.UPDATE_SHARING_GROUP_PERMISSION}/${recordId}`, body)
    }
    deleteRecord = ({recordId}) => {
        return axiosRecordingResponse.get(`${API_MAP.RECORDING.DELETE_RECORD}?record_id=${recordId}`)
    }
    downloadMyRecord = ({recordId}) => {
        return axiosRecordingResponse.get(`${API_MAP.RECORDING.DOWNLOAD_RECORD}?record_id=${recordId}`)
    }
    getMyRecordDetailCC = ({recording_status=1, is_deleted=0, page=0, size=5, is_my_record=1, room_name="", orderBy=0, orderType=0, filterRecord=0}) => {
        return axiosClient.get(API_MAP.GET_MY_RECORD_DETAIL + `?recording_status=${recording_status}&is_deleted=${is_deleted}&page=${page}&size=${size}&is_my_record=${is_my_record}&room_name=${room_name}&order_by=${orderBy}&order_type=${orderType}&filter_record=${filterRecord}`)
    }
    deleteOneRecord = (record_id) => {
        return axiosClient.get(API_MAP.DELETE_ONE_RECORD + `?record_id=${record_id}`)
    }
    deleteRecordIds = ({body}) => {
        return axiosRecordingResponse.post(`${API_MAP.RECORDING.DELETE_RECORD_IDS}`, body)
    }
}

const apiManagerRecordings = new ApiManagerRecordings();

export default apiManagerRecordings;
